import { LoggerModule, ApiModule } from "@packages/common";
import type { Module } from "@webmotors/ioc";

import { OffersService } from "./offers.service";

export const OffersModule: Module = {
  name: "OffersModule",
  modules: [ApiModule, LoggerModule],
  providers: [OffersService],
};
